export type MarketplaceSlotCapacity = {
  availabilityCount?: number;
  unlimitedAvailability?: boolean;
  bookedParticipants?: number;
  maxParticipants?: number;
  available?: boolean;
};

export function getMarketplaceSlotRemainingCapacity(
  slot: MarketplaceSlotCapacity
): number | undefined {
  if (slot.unlimitedAvailability) {
    return undefined;
  }

  let remaining: number | undefined;

  if (
    slot.maxParticipants !== undefined &&
    slot.bookedParticipants !== undefined
  ) {
    remaining = Math.max(0, slot.maxParticipants - slot.bookedParticipants);
  }

  if (slot.availabilityCount !== undefined) {
    remaining =
      remaining === undefined
        ? slot.availabilityCount
        : Math.min(remaining, slot.availabilityCount);
  }

  return remaining;
}

export function isMarketplaceSlotAvailable(
  slot: MarketplaceSlotCapacity | null | undefined
): boolean {
  if (!slot) return false;
  if (slot.unlimitedAvailability) return true;

  const remaining = getMarketplaceSlotRemainingCapacity(slot);
  if (remaining !== undefined) {
    return remaining > 0;
  }

  return slot.available === true;
}

export function isMarketplaceDateAvailable(
  timeSlots: Record<string, MarketplaceSlotCapacity> | undefined
): boolean {
  if (!timeSlots) return false;
  return Object.values(timeSlots).some((slot) =>
    isMarketplaceSlotAvailable(slot)
  );
}
